 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}
 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"runtime": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"avis-expert-avis-expert-module":"avis-expert-avis-expert-module","bet-settings-bet-settings-module":"bet-settings-bet-settings-module","bonus-details-bonus-details-module":"bonus-details-bonus-details-module","bonus-settings-bonus-settings-module":"bonus-settings-bonus-settings-module","cashout-settings-cashout-settings-module":"cashout-settings-cashout-settings-module","categories-categories-module":"categories-categories-module","category-category-module":"category-category-module","channel-detail-channel-detail-module":"channel-detail-channel-detail-module","channels-channels-module":"channels-channels-module","common":"common","footer-content-footer-content-module":"footer-content-footer-content-module","freebet-assignment-freebet-assignment-module":"freebet-assignment-freebet-assignment-module","nav-nav-module":"nav-nav-module","sport-promotions-sport-promotions-module":"sport-promotions-sport-promotions-module","dashboard-config-dashboard-config-module":"dashboard-config-dashboard-config-module","default~cagnotte-detail-cagnotte-detail-module~game-detail-game-detail-module~promotion-details-prom~cd2e0bb8":"default~cagnotte-detail-cagnotte-detail-module~game-detail-game-detail-module~promotion-details-prom~cd2e0bb8","cagnotte-detail-cagnotte-detail-module":"cagnotte-detail-cagnotte-detail-module","game-detail-game-detail-module":"game-detail-game-detail-module","promotion-details-promotion-details-module":"promotion-details-promotion-details-module","slides-details-slides-details-module":"slides-details-slides-details-module","default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~90c67f9e":"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~90c67f9e","default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~faa9ccf4":"default~client-detail-client-detail-module~partner-detail-partner-detail-module~partner-revenue-shar~faa9ccf4","default~client-detail-client-detail-module~partner-detail-partner-detail-module":"default~client-detail-client-detail-module~partner-detail-partner-detail-module","default~client-detail-client-detail-module~dashboard-dashboard-module":"default~client-detail-client-detail-module~dashboard-dashboard-module","client-detail-client-detail-module":"client-detail-client-detail-module","partner-detail-partner-detail-module":"partner-detail-partner-detail-module","partner-revenue-share-details-partner-revenue-share-details-module":"partner-revenue-share-details-partner-revenue-share-details-module","payments-details-payments-details-module":"payments-details-payments-details-module","default~dashboard-dashboard-module~suspended-tickets-suspended-tickets-module~tickets-tickets-module":"default~dashboard-dashboard-module~suspended-tickets-suspended-tickets-module~tickets-tickets-module","default~dashboard-dashboard-module~tickets-tickets-module":"default~dashboard-dashboard-module~tickets-tickets-module","dashboard-dashboard-module":"dashboard-dashboard-module","default~suspended-tickets-suspended-tickets-module~tickets-tickets-module":"default~suspended-tickets-suspended-tickets-module~tickets-tickets-module","tickets-tickets-module":"tickets-tickets-module","suspended-tickets-suspended-tickets-module":"suspended-tickets-suspended-tickets-module","default~game-lists-game-lists-module~publicity-publicity-module~slidder-detail-slidder-detail-module~1044debe":"default~game-lists-game-lists-module~publicity-publicity-module~slidder-detail-slidder-detail-module~1044debe","publicity-publicity-module":"publicity-publicity-module","game-lists-game-lists-module":"game-lists-game-lists-module","slidder-detail-slidder-detail-module":"slidder-detail-slidder-detail-module","text-slidders-text-slidders-module":"text-slidders-text-slidders-module","default~goal-goal-config-module~monitored-values-monitored-values-module~threshold-rules-threshold-r~d9c0906a":"default~goal-goal-config-module~monitored-values-monitored-values-module~threshold-rules-threshold-r~d9c0906a","default~goal-goal-config-module~threshold-rules-threshold-rules-module":"default~goal-goal-config-module~threshold-rules-threshold-rules-module","goal-goal-config-module":"goal-goal-config-module","default~manage-clients-manage-clients-module~manage-exclusions-manage-exclusions-module~manage-limit~65cc4550":"default~manage-clients-manage-clients-module~manage-exclusions-manage-exclusions-module~manage-limit~65cc4550","manage-clients-manage-clients-module":"manage-clients-manage-clients-module","manage-exclusions-manage-exclusions-module":"manage-exclusions-manage-exclusions-module","manage-limits-manage-limits-module":"manage-limits-manage-limits-module","demo-accounts-management-demo-accounts-management-module":"demo-accounts-management-demo-accounts-management-module","event-detail-event-detail-module":"event-detail-event-detail-module","event-restriction-event-restriction-module":"event-restriction-event-restriction-module","events-events-module":"events-events-module","group-detail-group-detail-module":"group-detail-group-detail-module","group-group-module":"group-group-module","limits-management-limits-management-module":"limits-management-limits-management-module","manual-market-manual-market-module":"manual-market-manual-market-module","market-detail-market-detail-module":"market-detail-market-detail-module","market-market-module":"market-market-module","notification-detail-notification-detail-module":"notification-detail-notification-detail-module","notification-settings-notifications-module":"notification-settings-notifications-module","package-config-package-config-module":"package-config-package-config-module","package-detail-package-detail-module":"package-detail-package-detail-module","partner-revenue-share-partner-revenue-share-module":"partner-revenue-share-partner-revenue-share-module","partners-partners-module":"partners-partners-module","payments-payments-module":"payments-payments-module","phone-numbers-phone-numbers-module":"phone-numbers-phone-numbers-module","product-type-product-type-module":"product-type-product-type-module","products-products-module":"products-products-module","promotions-promotions-module":"promotions-promotions-module","providers-providers-module":"providers-providers-module","results-results-module":"results-results-module","risk-configurations-risk-configurations-module":"risk-configurations-risk-configurations-module","speciale-cagnotte-speciale-cagnotte-module":"speciale-cagnotte-speciale-cagnotte-module","sport-details-sport-details-module":"sport-details-sport-details-module","sports-sports-module":"sports-sports-module","tax-configuration-tax-configurations-module":"tax-configuration-tax-configurations-module","tax-detail-tax-detail-module":"tax-detail-tax-detail-module","tax-payment-tax-payment-module":"tax-payment-tax-payment-module","threshold-config-threshold-config-module":"threshold-config-threshold-config-module","tournament-detail-tournament-detail-module":"tournament-detail-tournament-detail-module","tournaments-tournaments-module":"tournaments-tournaments-module","dashboard-detail-dashboard-detail-module":"dashboard-detail-dashboard-detail-module","limits-limits-module":"limits-limits-module","thresholds-thresholds-module":"thresholds-thresholds-module","monitored-values-monitored-values-module":"monitored-values-monitored-values-module","threshold-rules-threshold-rules-module":"threshold-rules-threshold-rules-module","threshold-rule-groups-threshold-rule-groups-module":"threshold-rule-groups-threshold-rule-groups-module"}[chunkId]||chunkId) + "-es2015.js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							var error = new Error('Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')');
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
